<template>
  <div class="page-account">
    <div class="container">
      <div class="page-account-top">
        <img src="../assets/logo.png" style="width: 60px;"
             alt="logo">
      </div>
    </div>
    <div class="page-account-container"></div>
    <div class="login">
      <div style="max-width: 500px">
        <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form">
          <div class="title">中科亚欧科学技术中心综合素质能力评价及成果展示查询平台</div>
          <el-form-item prop="username">
            <el-input v-model="loginForm.username" type="text" auto-complete="off"
                      placeholder="请输入用户名">
              <img slot="prefix" src="../assets/icons/ic_avatar.png" style="width: 12px;height: 12px;"/>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="loginForm.password" type="password" auto-complete="off"
                      placeholder="请输入密码"
                      @keyup.enter.native="handleLogin">
              <img slot="prefix" src="../assets/icons/ic_pwd.png" style="width: 12px;height: 12px;"/>
            </el-input>
          </el-form-item>

          <el-form-item style="width:100%;">
            <el-button :loading="loading" size="mini" type="primary" style="width:100%;height: 32px;"
                       @click.native.prevent="handleLogin">
              <span v-if="!loading">登录</span>
              <span v-else>正在载入官方数据...</span>
            </el-button>
          </el-form-item>
          <div class="" style="color: #ccc;font-size: 12px;margin-top: 53px;">
            <div> https://mailx.feiyiyishu.top</div>
            <div>中科亚欧科学技术中心综合素质能力评价及成果展示查询平台</div>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {getUserInfo, login} from '@/api/inter.js'

export default {
  name: "LoginPage",
  data() {
    return {
      codeUrl: "",
      loginForm: {
        username: "",
        password: ""
      },
      loginRules: {
        username: [{
          required: true,
          trigger: "blur",
          message: "请输入用户名"
        }],
        password: [{
          required: true,
          trigger: "blur",
          message: "请输入密码"
        }]
      },
      loading: false,
    };
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true;
          login(this.loginForm).then(res => {
            console.log("登录信息：", res);
            if (res.code !== 200) {
              this.$message({
                message: res.msg,
                type: 'error'
              });
              this.loading = false
            } else {
              localStorage.setItem('token', res.token)
              getUserInfo().then(succ => {
                console.log(succ);
                if (res.code == 200) {
                  localStorage.setItem('userInfo', JSON.stringify(succ.data))
                  this.$router.push('/index')
                }
              })
            }
          }).catch(error => {
            this.loading = false
            console.log(error);
          })
        }
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
body {
  margin: 0;
  height: 100vh;
}

.login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-size: 100% 100%;
  margin: 20px;
}

.title {
  font-size: 24px;
  font-weight: 500;
  color: rgba(0, 0, 0, .85);
  padding-top: 36px;
  margin-bottom: 31px;
}

.login-form {
  // width: 270px;
  padding: 0 40px 32px 40px;
  box-shadow: 0 2px 9px 6px rgba(0, 0, 0, .03);
  border-radius: 5px;
  background-color: #fff;
  text-align: center;
  margin: 0 1px;

  .el-input {
    height: 32px;

    input {
      height: 32px;
    }

    img {
      width: 14px;
      margin-left: 4px;
    }
  }


}


.page-account {
  margin: 0;
  padding: 0;

  .container {
    width: 100%;
    height: 350px;
    background-image: url(https://mailx.nychkc.com/store/view_admin/img/bg.4a0cce3e.png);
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: cover;

    .page-account-top {
      padding-top: 15px !important;
      padding-left: 20px !important;
    }
  }

  .page-account-container {
    box-shadow: 0 2px 9px 6px rgba(0, 0, 0, .03);
    border-radius: 5px;
    margin-top: -210px;
    background-color: #fff;
  }
}
</style>
